import { createStyles } from '@material-ui/core/styles';

export const OrderRecallStyles = createStyles({
    OrderRecallContainer: {
        'maxWidth': '100%',
        'height': 554,
        'display': 'flex',
        'flexDirection': 'column',
        '@media screen and (max-width: 770px)': {
            height: 582,
        },
        '@media screen and (max-width: 428px)': {
            height: 624,
        }
    },
    grid: {
        'maxWidth': '100% !important',
        'height': 442,
        '& .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td.dx-focused': {
            background: '#e6e6e6 !important'
        },
        '& .dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td:focus': {
            outline: 'unset'
        },
        '& .dx-datagrid-focus-overlay': {
            border: 'none',
        },
    },
    OrderRecallToogleContaner: {
        'display': 'flex',
        'flexDirection': 'column',
        'backgroundColor': '#dddddd',
        'bottom': 0,
        'position': 'sticky',
        'zIndex': 2,
        'width': '100%',
        'height': '38px',
        '& label': {
            paddingLeft: '16px',
            background: '#dddddd'
        }
    }
});

export const toggleStyles = createStyles({
    switchBase: {
        '&$checked': {
            '& + $bar': {
                backgroundColor: '#6DD900',
                opacity: 1
            },
        },
    },
    bar: {},
    checked: {},
    formControlLabel: {
        '&$disabled': {
            color: '#555555',
        },
    },
    disabled: {

    },
});
